import { Platform } from 'react-native';

/** Routes where the floating create button should be hidden. */
export const HIDE_FAB_ROUTES: string[] = [
  'create',
  'tutorial',
  'onboarding',
  'oauth-native-callback',
  'oauth-gmail-callback',
  'privacy-and-data',
  'legal',
  'league-detail',
  'match',
  'games', // Warmup is a self-contained game surface; the create FAB would overlap its keyboard.
  'rank-ladder', // The Climb is a full-screen takeover; the FAB would float over the scene.
];

/**
 * Base offset from the bottom of the screen so the FAB rests on the tab bar.
 * On iOS, `useSafeAreaInsets().bottom` is added at runtime so the FAB tracks
 * the tab bar above the home indicator. Web has no home indicator and its tab
 * bar sits lower, so the FAB is nudged down to rest on the bar rather than float
 * above it.
 */
export const FAB_BOTTOM_OFFSET = Platform.select({ android: 22, web: 22, default: 0 });

/** Plus glyph on the FAB — always white on the primary fill (avoid theme.onPrimary / SVG quirks on iOS). */
export const FAB_PLUS_ICON_COLOR = '#FFFFFF';
